// removed by extract-text-webpack-plugin
module.exports = {"paper":"paper__zTr_B","mandate":"mandate__888ek","address-kyc":"address-kyc__16Gn3","switch":"switch__3xwC3","slider":"slider__MFjFO","round":"round__3q3mp"};


//////////////////
// WEBPACK FOOTER
// ./styles/field.scss
// module id = 1106
// module chunks = 68